import React from 'react';
import Storage from '../Helpers/Storage/Storage';
import './Home.css';

const Home = () => (
  <div className="home">
    <h1>Herzlich willkommen bei</h1>
    <div><img src={Storage.get('logo')} alt="logo" /></div>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/pages/Home/index.js